<div class="container col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
    <!-- <div class="col-sm-6 col-md-6 col-xl-4 m-auto text-left">
        <div class="custom-control custom-checkbox chkbox mb-2">
            <input type="checkbox" class="custom-control-input mgntp10" id="Rent" value="Rent" name="rent_own"
                [(ngModel)]="hgValue.value1" (click)="getValue($event)" />
            <label class="custom-control-label font20" for="Rent">Rent</label>
        </div>
        <div class="custom-control custom-checkbox chkbox mb-2">
            <input type="checkbox" class="custom-control-input mgntp10" id="Own" value="Own" name="rent_own"
                [(ngModel)]="hgValue.value2" (click)="getValue($event)" />
            <label class="custom-control-label font20" for="Own">Own</label>
        </div>
    </div> -->
    <div class="col-sm-12">
        <div class="d-flex  m-auto col-sm-6 col-md-6 col-xl-8">
            <div class="col-6 q-cards">
                <label class="card card-list pt-2 text-center d-inline-block pull-right" for="Rent">
                    <img src="{{rent_src}}" height="100px">
                    <div></div>
                    <label for="Rent">Rent</label>
                    <div class="custom-control custom-checkbox boxchkbox chkbox shadow-none mb-2">
                        <input type="checkbox" class="custom-control-input mgntp10" id="Rent" value="Rent" name="rent_own"
                            [(ngModel)]="hgValue.value1" (click)="getValue($event)" />
                        <label class="custom-control-label" for="Rent"></label>
                    </div>
                </label>
            </div>
            <div class="col-6 q-cards">
                <label class="card card-list pt-2 text-center d-inline-block pull-left" for="Own">
                    <img src="{{own_src}}" height="100px">
                    <div></div>
                    <label for="Own">Own</label>
                    <div class="custom-control custom-checkbox boxchkbox chkbox shadow-none mb-2">
                        <input type="checkbox" class="custom-control-input mgntp10" id="Own" value="Own" name="rent_own"
                            [(ngModel)]="hgValue.value2" (click)="getValue($event)" />
                        <label class="custom-control-label" for="Own"></label>
                    </div>
                </label>
            </div>
        </div>
    </div>
    <p class="m-0 mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    <button *ngIf="showbutton" class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'sectbtn': isChecked}"(click)="next();">Next</button>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id">
        <div class="d-flex h-100 row col-sm-12 pr-0">
                <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
            <img style="width:100%;" src="assets/images/signimg.jpg" />
        </div>
        <div class="col-sm-9 col-9 px-0 my-auto">
            <div class="arrow_box" >
                    <h1 class="questionMob text-left"><span class="align-middle">{{question}}</span></h1>
            </div>
        </div>
    </div>
    <div class="row col-sm-12 m-auto">
        <div class="d-flex mt-2">
            <div class="col-6 pl-0 box-shadow-none">
                <label class="col-12 card card-list text-center d-inline-block" for="Rent" style="min-height: 126px;">
                    <img src="{{rent_src}}" width="60%">
                    <label for="Rent" class="col-12 mt-1">Rent</label>
                    <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                        <input type="checkbox" class="custom-control-input mgntp10" id="Rent_mob" value="Rent" name="rent_own"
                            [(ngModel)]="hgValue.value1" (click)="getValue($event)" />
                        <label class="custom-control-label" for="Rent"></label>
                    </div>
                </label>
            </div>
            <div class="col-6 pr-0 box-shadow-none">
                <label class="col-12 card card-list text-center d-inline-block" for="Own" style="min-height: 126px;">
                    <img src="{{own_src}}" width="60%" class="mt-1">
                    <label for="Own" class="col-12">Own</label>
                    <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                        <input type="checkbox" class="custom-control-input mgntp10" id="Own_mob" value="Own" name="rent_own" [(ngModel)]="hgValue.value2"
                            (click)="getValue($event)" />
                        <label class="custom-control-label" for="Own"></label>
                    </div>
                </label>
            </div>
        </div>
        <!-- <p class="m-auto text-muted tapmsg">{{questionObj.chkboxtype}}</p> -->
        <!-- <div style="width:96% !important; text-align: right;">
        <div *ngIf="user_bot" class="ash_box text-right mt-2" >
            <h1 class="ansMob text-right">{{rent_own}}</h1>
        </div>
        </div> -->
    </div>
</div>
<!-- <div class="btm-process webview">
    <div class="text-center" *ngIf="!messagetype">
      <span><img src="assets/images/active10.png"></span>
      <h4 class="clr333 processtxt">15% Completed</h4>
    </div>
    <div class="text-center" *ngIf="messagetype">
        <span><img src="assets/images/active6.png"></span>
        <h5 class="clr333 processtxt">30% Completed</h5>
      </div>
  </div> -->